import React, { useEffect, useRef, useState } from "react";
import { FaStar } from "react-icons/fa";

const testimonials = [
  {
    text: "Muito bom o atendimento, sempre esclarecedor e atencioso, diminuindo muito o problema do acidente, Rafael atendimento nota 10, abraço e obrigado",
    name: "Mario Almeida",
    since: "Cliente desde 2018",
    avatar:
      "https://lh3.googleusercontent.com/a/ACg8ocLv6lpZUTYeN400d5WyJUWSr9UPQ6WBXMKBrHLFNy0SmBUuKw=s36-c-rp-mo-br100",
  },
  {
    text: "Excelente atendimento e rapidez nas solicitações.",
    name: "Flavio Ribeiro",
    since: "Cliente desde 2021",
    avatar:
      "https://lh3.googleusercontent.com/a/ACg8ocJeKNoGflri1mlsfjFbhBBN63LqI3SG39u2SmfDq9DqoRTOjg=s36-c-rp-mo-br100",
  },
  {
    text: "Excelente prestação de serviço e atendimento.",
    name: "Claret Freitas",
    since: "Cliente desde 2019",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjXayl940NyWR2WzVahjQY2VfYiFl2guXKCGmfebNT4_oS8-QJP9DQ=w72-h72-p-rp-mo-ba3-br100",
  },
  {
    text: "O corretor foi gentil e atencioso, esclareceu todas as dúvidas e encontrou um seguro ideal para meu orçamento. Gratidão!",
    name: "Ivone Nunes",
    since: "Cliente desde 2011",
    avatar:
      "https://lh3.googleusercontent.com/a/ACg8ocJba_rrRiBqvbgBadcPiS3O4npKXaYTu-6WGD1ggWxOSoixUQ=w72-h72-p-rp-mo-br100",
  },
];

function AnimatedOnScroll({ children, className = "" }) {
  const ref = useRef();
  const isVisible = useOnScreen(ref);

  return (
    <div
      ref={ref}
      className={`opacity-0 translate-y-8 transition-all duration-700 ease-out ${
        isVisible ? "opacity-100 translate-y-0" : ""
      } ${className}`}
    >
      {children}
    </div>
  );
}

function useOnScreen(ref) {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting),
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref]);

  return isIntersecting;
}

function TestimonialCard({ testimonial }) {
  const ref = useRef();
  const isVisible = useOnScreen(ref);

  return (
    <div
      ref={ref}
      className={`bg-white p-6 rounded-lg shadow-md flex flex-col justify-between min-h-[320px] opacity-0 translate-y-8 transition-all duration-700 ease-out ${
        isVisible ? "opacity-100 translate-y-0" : ""
      }`}
    >
      <div>
        <div className="flex text-yellow-400 mb-4">
          {[...Array(5)].map((_, i) => (
            <FaStar key={i} />
          ))}
        </div>
        <p className="text-gray-600 mb-6 leading-relaxed">
          "{testimonial.text}"
        </p>
      </div>
      <div className="flex items-center mt-auto">
        <div className="w-12 h-12 rounded-full overflow-hidden mr-4 border border-gray-300 flex-shrink-0">
          <img
            src={testimonial.avatar}
            alt={testimonial.name}
            className="w-full h-full object-cover"
          />
        </div>
        <div>
          <p className="font-semibold">{testimonial.name}</p>
          <p className="text-sm text-gray-500">{testimonial.since}</p>
        </div>
      </div>
    </div>
  );
}

<style jsx>{`
  @keyframes fadeInUp {
    0% {
      opacity: 0;
      transform: translateY(10px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .fadeInUp {
    animation-name: fadeInUp;
    animation-duration: 800ms;
    animation-fill-mode: forwards;
    animation-timing-function: ease-out;
  }
`}</style>;

const TestimonialsSection = () => {
  const sectionRef = useRef();
  const sectionVisible = useOnScreen(sectionRef);
  return (
    <section
      ref={sectionRef}
      className={`py-8 bg-slate-100 transition-opacity duration-700 ${
        sectionVisible ? "fadeInUp" : "opacity-0"
      }`}
    >
      <div className="container mx-auto px-4">
        <AnimatedOnScroll>
          <h2 className="text-xl font-semibold text-blue-950 mb-3">
            DEPOIMENTOS
          </h2>
        </AnimatedOnScroll>

        <AnimatedOnScroll>
          <h2 className="text-3xl sm:text-4xl font-bold text-blue-950 mb-4">
            O que dizem sobre a Free Market
          </h2>
        </AnimatedOnScroll>

        <AnimatedOnScroll>
          <p className="text-lg sm:text-xl text-blue-950 mb-12">
            Histórias reais mostram o que somos na prática: atendimento ágil,{" "}
            <br />
            cuidado de verdade e soluções sob medida. É assim que conquistamos{" "}
            <br />a confiança de quem já passou por aqui — e continua com a
            gente.
          </p>
        </AnimatedOnScroll>

        <div className="max-w-5x1 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {testimonials.map((t, i) => (
            <TestimonialCard key={i} testimonial={t} />
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="https://g.co/kgs/fz2vvYi"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-700 font-semibold hover:underline"
          >
            Ver mais comentários no Google &rarr;
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
